const carouselTime = document.getElementById('carousel');
const slides = document.querySelectorAll('.slide');
let currentIndex = 0;

function showSlide(index) {
    slides.forEach((slide, i) => {
    if (i === index) {
        slide.classList.add('active');
    } else {
        slide.classList.remove('active');
    }
    slide.classList.remove('slide-next');
    slide.classList.remove('slide-prev');
    });
}

function showNextSlide() {
    slides[currentIndex].classList.add('slide-prev');
    currentIndex = (currentIndex + 1) % slides.length;
    slides[currentIndex].classList.add('slide-next');
    setTimeout(() => {
    showSlide(currentIndex);
    }, 300);
}

const intervalSeconds = carousel.getAttribute('data-time-duration');
setInterval(showNextSlide, intervalSeconds * 1000);

showSlide(currentIndex);
  